import React, {Component} from 'react';

import './TraineeBadge.css'
import {Badge} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiagramProject, faUser} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

class TopicBadge extends Component {
    constructor(props) {
        super(props);
        this.topic = props.topic;
    }
    render() {
        return(
            <Badge style={{marginRight:'0.2em',marginBottom:'0.2em'}}
                   className={"topicBadge"} bg="dark">
                <FontAwesomeIcon icon={faDiagramProject}/> {this.topic.projectId}
            </Badge>
        )
    }
}
export default TopicBadge;